import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { TextAreaFormField } from '@playbookux/playbook-web-core';

import {
  Container,
  ContainerTitle,
  IconTitle,
  Title,
  QuestionIndex,
} from './styles';

import ErrorMessage from '../error';

const WrittenQuestion = (props) => {
  const {
    index,
    errors,
    touched,
    taskIndex,
    testType,
  } = props;

  let label = '';

  if (testType === 'survey') {
    label = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.label`;
  } else {
    label = `${(taskIndex || taskIndex === 0) ? `tasks[${taskIndex}]` : ''}tasks.${index}.label`;
  }

  return (
    <Container>
      <ContainerTitle>
        <QuestionIndex>{index + 1}</QuestionIndex>
        <IconTitle src="/images/question-written.png" />
        <Title color="questionTitleWritten">
          Written Response
        </Title>
      </ContainerTitle>
      <Field
        placeholder="Start typing your question"
        minWidth="100%"
        component={TextAreaFormField}
        name={label}
      />
      <ErrorMessage
        index={index}
        errors={errors}
        touched={touched}
      />
    </Container>
  );
};

WrittenQuestion.propTypes = {
  index: PropTypes.number.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  taskIndex: PropTypes.number,
  testType: PropTypes.string.isRequired,
};

WrittenQuestion.defaultProps = {
  taskIndex: null,
};

export default WrittenQuestion;
